import create from 'utils/command'
import {associate} from 'utils/functions' 
import {initAnswer} from 'utils/assessment'
import immutableUpdate from 'external/immutability-helper'

const hooks =  [
  {paths: ['refreshAssessments', 'props/params/section', 'props/query/orderBy', 'props/query/page'], resolves: [fetchAssessments]},
  {paths: ['props/params/assessmentId', 'types/', 'questionTypes/'], resolves: [fetchAssessment]}
]

export {hooks as default}

export async function fetchTypes ({state, update}) {
  if (state.types) return
  const types = await create('quiz', 'getTypes')()
  const typesMap = associate('id', 'name')(types)
  const questionTypes = await create('quiz', 'getQuestionTypes')()
  update({$shallow: {types, typesMap, questionTypes}})
}


export async function fetchAssessments({state, update}, {path}) {
  const {props: {query, params}} = state
  const {groupId: clique, section, pageName, assessmentId} = params
  if (pageName != 'my-courses' || section != 'assessment' || !clique || assessmentId != undefined) return
  if (!path || !path.startsWith('props/query')) update({assessments: {$set: undefined}}) // Clear assessments unless is updating a query parameter
  const assessments = await create('student', 'searchAssessments')({...query, clique})
  update({assessments: {$set: assessments}})
}

export async function fetchAssessment ({state, update, props}, {path}) {
  const {props: {params}, types, questionTypes} = state
  const {groupId: clique, pageName, assessmentId} = params
  if (pageName != 'my-courses' || !clique || !assessmentId || !types || !questionTypes) return
  update({assessmentLoaded: {$set: false}, assessment: {$set: {}}})
  const [data] = await create('quiz','getStudentAssessment')({id: assessmentId})
  const assessment = Object.values(data.content.sections).reduce((assessment, section) =>
    section.questions.reduce((assessment, question) =>
      immutableUpdate(assessment, {answers: {[question.id]: {$apply: initAnswer(questionTypes, question)}}})
      , assessment)
  , data)
  update({assessmentLoaded: {$set: true}, assessment: {$set: assessment}})
}
